RivalIQ.apps.Discovery.module('utils', function (utils, App, Backbone, Marionette, $, _, s) {

    'use strict';

    utils.SEGMENT_COUNT = 4;

    utils.validCurationOptions = App.enums.filterableDimensionPropKeys.concat([
        'channel',
        'searchTerm',
        'searchType',
        'followerCountLow',
        'followerCountHigh'
    ]);

    utils.validWidgetOptions = utils.validCurationOptions.concat(['instanceId', 'limit', 'sortOrder', 'orderBy']);

    utils.generateProfileLinks = function (screenName, channel) {
        if (channel === RivalIQ.enums.channels.INSTAGRAM) {
            if (screenName.startsWith('@')) {
                screenName = screenName.slice(1);
            }
            return {
                presence_link: `https://instagram.com/${screenName}`,
                follow_link: '' // this doesn't exist for insta, but leave this here to keep return structure consistent
            };
        } else { // return the twitter links
            return {
                presence_link: `https://twitter.com/${screenName}`,
                follow_link: `https://twitter.com/intent/follow?screen_name=${screenName}`
            };
        }
    };

    utils.getOrderBy = function (propable) {
        // set default
        let definition = {
            channel: propable.getProp('channel'),
            dimensions: ['channel', 'postId'],
            property: (propable.channel === RivalIQ.enums.channels.TWITTER ? 'presence_reach' : 'engagement_total')
        };

        const orderBy = propable.getProp('orderBy');
        if (_.isFinite(orderBy)) {
            const metric = propable.dashboardModel.metricsCollection.at(orderBy);
            if (metric) {
                definition = metric.toType();
            }
        } else if (_.isObject(orderBy)) {
            definition = orderBy;
        }

        return definition;
    };

    utils.trackFilterLinkClick = function (eventTarget, dashboardModel) {
        const newFilterValue = eventTarget.data('filter-value') || eventTarget.parents('.x-filter-results').data('filter-value');
        const filterDimension = eventTarget.data('filter-dimension') || eventTarget.parents('.x-filter-results').data('filter-dimension');

        RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.DiscoveryAddFilter, {
            channel: dashboardModel.getProp('channel'),
            filterValue: newFilterValue,
            filterDimension: filterDimension
        });
    };

    utils.getFilterUrl = function (filterDimension, newFilterTerm, dashboardModel) {
        const filtersPropKey = `${filterDimension}Filters`;

        // NOTE: I'm looking for the existence of instanceId instead of relying on isFocus() here
        // as it's possible that the table is embedded in another widget that does have focus.
        const propsToPick = (dashboardModel.getProp('instanceId') ?
            App.utils.validWidgetOptions : App.utils.validCurationOptions);

        const params = _.pick(dashboardModel.getProps(), propsToPick);
        const existingFilters = params[filtersPropKey] || [];
        const exists = _.some(existingFilters, function (term) {
            return term.toLowerCase() === newFilterTerm;
        });
        params[filtersPropKey] = (exists ? existingFilters : existingFilters.concat(newFilterTerm));

        return RivalIQ.apps.Dashboard.router.router.resolveCurationRoute(
            RivalIQ.enums.curation.DISCOVERY,
            params
        );
    };

    utils.getAnalyzeAccountUrl = function (dashboardModel, accountHandle) {
        const params = _.pick(dashboardModel.getProps(), 'channel');
        params.searchTerm = `from:${accountHandle}`;

        return RivalIQ.apps.Dashboard.router.router.resolveCurationRoute(
            RivalIQ.enums.curation.DISCOVERY,
            params
        );
    };

    utils.getInfluencerScoreSegment = function (influencerScore) {
        return Math.min(utils.SEGMENT_COUNT, Math.ceil(influencerScore * (utils.SEGMENT_COUNT - 1)));
    };

    utils.haveTokenFromUser = function (curation) {
        return _.some(curation.accessiblePresences, function (accessiblePresence) {
            return _.includes(accessiblePresence.userIds, RivalIQ.state.user.id);
        });
    };

    function toHashtag(s) {
        return (s ? `#${s}` : s);
    }

    const WIDGET_FILTER_CONFIGURATIONS = utils.WIDGET_FILTER_CONFIGURATIONS = [
        {
            prop: 'searchTerm',
            name: 'query'
        },
        {
            prop: 'hashtagFilters',
            name: 'hashtag',
            valueTransform: toHashtag
        },
        {
            prop: 'mentionFilters',
            name: 'mention'
        },
        {
            prop: 'postAuthorFilters',
            name: 'author'
        },
        {
            prop: 'sharedUrlFilters',
            name: 'shared url'
        },
        {
            prop: 'frequentTermFilters',
            name: 'frequent term'
        },
        {
            prop: 'influencerBioTermFilters',
            name: 'influencer bio term'
        }
    ];

    utils.constructAppliedFilters = function (configuration, props) {
        return _.reduce(configuration, function (memo, config) {
            const value = props[config.prop];

            let values;
            if (_.isArray(value)) {
                values = value;
            } else {
                values = [value];
            }

            const valueTransform = _.get(config, 'valueTransform', _.identity);
            const sanitizedValues = _.reduce(values, function (acc, value) {
                const sanitizedValue = valueTransform(s.trim(value));
                return (_.isEmpty(sanitizedValue) ? acc : acc.concat(sanitizedValue));
            }, []);

            if (_.isEmpty(sanitizedValues)) {
                return memo;
            }

            const nameTransform = _.get(config, 'nameTransform', _.identity);
            const label = [nameTransform(config.name), sanitizedValues.join(',')].join(': ');

            return memo.concat(label);
        }, []);
    };

    function constructAppliedFiltersText(props) {
        const appliedFilters = utils.constructAppliedFilters(WIDGET_FILTER_CONFIGURATIONS, props);
        if (appliedFilters.length) {
            return [' (', appliedFilters.join(', '), ')'].join('');
        } else {
            return '';
        }
    }

    utils.exportTitle = function () {
        const me = this;
        const title = _.result(me, 'title');

        // NOTE PPT uses a subtitle to show search term
        if (!me.isFocus() || me.isExportingPPT()) {
            return title;
        }

        return [title, constructAppliedFiltersText(me.getProps())].join('');
    };

    function getTimePeriod(propable) {
        let timePeriod = propable.getProp('timePeriod');

        const timePeriodType = propable.getProp('timePeriodType');
        if (timePeriodType) {
            timePeriod = RivalIQ.state.timePeriods.getByType(timePeriodType);
        }

        return timePeriod;
    }

    function getTimePeriodDisplayString(propable) {
        const timePeriod = getTimePeriod(propable);
        const timePeriodDisplayString = RivalIQ.utils.timePeriod.getTimePeriodDisplayString(timePeriod);
        return timePeriodDisplayString;
    }

    utils.exportSubtitle = function (options) {
        const me = this;

        if (!me.isFocus()) {
            return;
        }

        const channel = RivalIQ.props.getChannel(me.getProps());
        const channelName = channel.get('name');

        const timePeriodDisplayString = getTimePeriodDisplayString(me);

        const multiLine = _.get(options, 'multiLine');
        // fancy formats like PDF headers need the individual elements
        // everyone else just wants a reasonably formatted string
        if (multiLine) {
            return [
                channelName,
                timePeriodDisplayString
            ];
        } else {
            return [
                channelName,
                ', ',
                timePeriodDisplayString
            ].join('');
        }
    };

    utils.pptSubtitle = function () {
        const me = this;
        const timePeriodDisplayString = getTimePeriodDisplayString(me);
        return [timePeriodDisplayString, constructAppliedFiltersText(me.getProps())].join(' ');
    };

    utils.getExportFilename = function (useTitle) {
        const me = this;

        let title;
        if (useTitle !== false) {
            title = me.getTitle();
        }

        const channel = RivalIQ.data.channels.get(me.getProp('channel'));

        const filename = RivalIQ.export.filename.base({
            appName: 'discover',
            channel: channel.get('name'),
            title: title
        });

        return filename;
    };

    utils.getColumnSortOrder = function (metricsCollection, orderBy) {

        // break ties with avg_engagement_rate_per_post
        orderBy = _.isArray(orderBy) ? orderBy : [orderBy];
        const engRatePerPostIdx = _.findIndex(metricsCollection.models, function (metric) {
            return metric.get('property') === 'avg_engagement_rate_per_post';
        });
        if (engRatePerPostIdx !== -1) {
            orderBy = _.uniq(orderBy.concat(engRatePerPostIdx));
        }

        return metricsCollection.getColumnSortOrder(orderBy);
    };

    utils.getOrderByString = function (sortColumns, metricsCollection) {
        return _(sortColumns)
            .map(function (idx) {
                if (idx < metricsCollection.length) {
                    return metricsCollection.at(idx).getOrderBy();
                }
            })
            .compact()
            .take(3) // saves the server from having to calculate all the metrics
            .value()
            .join(',');
    };

}, window.s);
